import React from 'react'; 
import './Hero.css';

const HeroContent = () => { 
    return ( 
        <div id='home' className='hero'>  
            <h1 className='hero-name'>Ghulam Afzal</h1>
            <p className='hero-about-me'>I am currently a junior attending the University of Connecticut as a computer science student. I have a passion for web development, game development, and embedded programming.</p>
        </div>
    )    

}

export default HeroContent; 